<div #element id="notificationbar">
  <p-messages />
</div>
